/**
 * 服務機構 PC 頁 — 繁體中文（嵌套結構，對應 t('serviceInstitution.pc.…')）
 */
export default {
	joinHeader: {
		title: "機構入駐先知命局",
		subtitle: "與全球優質服務機構同行，共建合規、可信賴的靈性服務生態",
	},
	demo: {
		categories: {
			all: "全部",
			nearby: "附近",
		},
		search: {
			rootTitle: "服務機構",
			placeholder: "輸入服務、機構名稱",
			searchBtn: "搜尋",
			hotCategories: "熱門分類",
			recommendTitle: "推薦機構",
			mapFullscreenAria: "全屏",
			closeMapAria: "關閉地圖",
			zoomInAria: "放大",
			zoomOutAria: "縮小",
			resultTitle: "搜尋結果",
			resultCount: "共找到{count}條結果",
			reviewCount: "{count}人已評價",
			favoritesCount: "{count}人已收藏",
			moreBtn: "查看更多結果",
			moreInstitutionsBtn: "查看更多機構",
			emptyResult: "暫無符合條件的機構",
			regionLoading: "區域載入中...",
		},
		detail: {
			backAria: "返回",
			defaultTip: "如需參觀或了解更多資訊，建議提前致電聯絡確認開放安排。",
			shareAria: "分享",
			shareCopied: "鏈接已複製",
			shareCopyFailed: "複製失敗，請重試",
			mapBtn: "地圖",
			phoneBtn: "電話",
			phoneCopied: "電話號碼已複製",
			phoneCopyFailed: "複製失敗，請重試",
			hoursTitle: "營業時間",
			introTitle: "機構介紹",
			servicesTitle: "特色服務",
			reviewsTitle: "評價",
			viewAllReviews: "查看全部",
			mediaTitle: "媒體",
			videoTab: "影片{count}",
			reviewCount: "{count}人已評價",
		},
		mock: {
			mapPin: [{ name: "尖沙咀" }, { name: "中環" }, { name: "油麻地" }],
			institution: [
				{
					name: "道教九霄道觀",
					type: "道觀",
					address: "香港八鄉錦上路石湖塘村八鄉錦上路石湖塘村",
					desc: "成立於二零零三年(癸未年), 主要供...",
					favorites: "3.6萬人已收藏",
					distance: "3.6km",
				},
				{
					name: "道教九霄道觀",
					type: "道觀",
					address: "香港八鄉錦上路石湖塘村八鄉錦上路石湖塘村",
					desc: "成立於二零零三年(癸未年), 主要供...",
					favorites: "3.6萬人已收藏",
					distance: "3.6km",
				},
			],
			detail: {
				title: "九龍清真寺",
				type: "清真寺",
				address: "日落洞（Jelutong）Jelutong Road 670-A號",
				intro:
					"檳城青龍宮（Penang Cheng Leong Keong）是馬來西亞檳城日落洞地區的一座道教廟宇，主祀保生大帝，同時供奉清水祖師、神農大帝、福德正神、觀音佛祖等神明。",
				tip: "如需參觀或了解更多資訊，建議提前致電聯絡確認開放安排。",
				hours: [
					{ label: "週一至週六", value: "08:30-17:00" },
					{ label: "週日", value: "08:30-22:00" },
				],
				highlights: [
					{ label: "成立時間：", value: "1895年" },
					{ label: "主祀神明：", value: "保生大帝" },
					{
						label: "其他供奉：",
						value:
							"清水祖師、神農大帝、福德正神、觀音佛祖、三十六天將、太歲爺、虎爺公、哪吒公、大二爺伯",
					},
					{ label: "開放時間：", value: "" },
					{ label: "", value: "平日：早上7:30至傍晚6:30" },
					{ label: "", value: "初一、十五：早上5:30至晚上7:00" },
				],
			},
		},
	},
};
